// src/oura/ui/CardEmpty.tsx
//
// The empty state inside a card: an icon bubble, a title that names what is
// missing, one sentence on what happens next, and an optional action (house
// style §9). It replaces the one grey line a card used to show, which read
// as a card that had failed to load rather than one with nothing in it yet.
//
// Card-sized: lower than the page-level EmptyState, so a pair of cards in a
// bento row keeps a sensible height when both are empty.

import type { ReactNode } from "react";
import type { LucideIcon } from "lucide-react";
import { cn } from "../lib/cn";
import { TYPE } from "./tokens";

export function CardEmpty({
    icon: Icon,
    title,
    children,
    action,
    className,
}: {
    icon: LucideIcon;
    title: string;
    /** What happens next, in one sentence. May hold a link. */
    children?: ReactNode;
    action?: ReactNode;
    className?: string;
}) {
    return (
        <div className={cn("flex flex-col items-center justify-center px-4 py-8 text-center", className)}>
            <span aria-hidden className="mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-gray-100">
                <Icon className="h-5 w-5 text-gray-400" />
            </span>
            <p className={cn(TYPE.tb, "m-0 font-medium text-gray-900")}>{title}</p>
            {children && <p className={cn(TYPE.tc, "m-0 mt-1 max-w-sm text-gray-500")}>{children}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}
